<div class="tasks-by-lpa">
  <!-- Filters Row (Horizontal) -->
  @if (isFilterVisible) {
    <div class="filters-row">
      <div class="horizontal-filters-container">
        <!-- Date Range Filter -->
        <div class="filter-item">
          <label>Date Range</label>
          <div class="calendar-container">
            <p-calendar
              [(ngModel)]="dateRangeValue"
              selectionMode="range"
              [readonlyInput]="true"
              [showIcon]="true"
              [minDate]="minDateValue"
              [maxDate]="maxDateValue"
              dateFormat="mm/dd/yy"
              placeholder="Select date range"
              [style]="{'width':'100%'}"
              (onSelect)="onDateRangeSelect($event)"
              (onClose)="onDateRangeClose($event)"
              [yearNavigator]="true"
              [monthNavigator]="true"
              yearRange="2020:2050">
            </p-calendar>
          </div>
        </div>
        <!-- Organization Filter -->
        <div class="filter-item">
          <label>Organization</label>
          <ng-select
            [items]="organizationOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select organization"
            [(ngModel)]="selectedOrganization"
            (change)="onOrganizationChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Matter Filter -->
        <div class="filter-item">
          <label>Matter</label>
          <ng-select
            [items]="matterOptions"
            bindLabel="name"
            bindValue="id"
            [placeholder]="selectedOrganization ? 'Select matter' : 'Select org first'"
            [(ngModel)]="selectedMatter"
            (change)="onMatterChange($event)"
            [clearable]="true"
            [disabled]="!selectedOrganization"
            class="custom-select multiline-dropdown">
            <ng-template ng-notfound-tmp>
              <div class="ng-option disabled">
                {{ selectedOrganization ? 'No matters found' : 'Please select an organization first' }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <!-- Project Filter -->
        <div class="filter-item">
          <label>Project</label>
          <ng-select
            [items]="projectOptions"
            bindLabel="name"
            bindValue="id"
            [placeholder]="selectedMatter ? 'Select project' : 'Select matter first'"
            [(ngModel)]="selectedProject"
            (change)="onProjectChange($event)"
            [clearable]="true"
            [disabled]="!selectedMatter"
            class="custom-select multiline-dropdown">
            <ng-template ng-notfound-tmp>
              <div class="ng-option disabled">
                {{ selectedMatter ? 'No projects found' : 'Please select a matter first' }}
              </div>
            </ng-template>
          </ng-select>
        </div>
        <!-- Practice Area Filter -->
        <div class="filter-item">
          <label>Practice Area</label>
          <ng-select
            [items]="practiceAreaOptions"
            bindLabel="name"
            bindValue="id"
            placeholder="Select practice area"
            [(ngModel)]="selectedPracticeArea"
            (change)="onPracticeAreaChange($event)"
            [clearable]="true"
            class="custom-select multiline-dropdown">
          </ng-select>
        </div>
        <!-- Apply and Clear Filters -->
        <div class="filter-actions">
          <button class="btn btn-primary apply-btn" (click)="applyFilters()">Apply</button>
          <button class="btn btn-outline-secondary clear-btn" (click)="clearFilters()">
            <i class="bx bx-x-circle"></i> Clear
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Chart Row -->
  <div class="row">
    <!-- Chart Column (Full Width) -->
    <div class="col-12 chart-column">
      <div #chartContainer class="chart-container">
        @if (isLoading) {
          <div class="loading-container">
            <div class="loading-spinner"></div>
          </div>
        }
        @if (!isLoading && chartData.length > 0) {
          <div class="chart-wrapper">
            <ngx-charts-bar-horizontal-stacked
              [view]="view"
              [scheme]="colorScheme"
              [results]="chartData"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [animations]="animations"
              [legendPosition]="legendPosition">
            </ngx-charts-bar-horizontal-stacked>
          </div>
        }
        @if (!isLoading && chartData.length === 0) {
          <div class="no-data-message">
            No task data available for the selected filters.
          </div>
        }
      </div>
    </div>
  </div>
</div>
